import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {paymentBody} from '../modals/props/props.interface';

@Injectable({
  providedIn: 'root'
})
export class PropsService {
// URLs
  private propsUrl = environment.baseURL + '/payment/notification';
  private propsMarketUrl = environment.baseURL + '/application/notification';
  private propsOrderSiteUrl = environment.baseURL + '/site/notification';

  private readonly destroy$ = new Subject<null>();

  constructor(
    private readonly http: HttpClient
  ) { }

  notifyAdmin(body: paymentBody): Observable<any> {
    return this.http.post<any>(this.propsUrl, {...body});
  }

  notifyOrderSite(body: any): Observable<any> {
    return this.http.post<any>(this.propsOrderSiteUrl, {...body});
  }

  notifyMarketAdmin(body: any): Observable<any> {
    return this.http.post<any>(this.propsMarketUrl, {...body});
  }

}
